import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box, Typography, Modal, Slider, Tooltip, IconButton, Button } from '@mui/material';
import { Close, Settings } from "@material-ui/icons";
import { PopoverPicker } from '../../../utils/PopoverPicker';
import "./styles.scss"
import { handleSettingsMenuState, panelClosing, postSettings, settingsPanel, soundSettings } from '../../../redux/actions/settings';
import { Switch } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import InputDeviceSetting from './InputDeviceSetting';

const useStyles = makeStyles({
    switchStyle: {
        "& .MuiIconButton-root": {
            width: 'initial',
            height: 'initial'
        }
    }
});

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: 3,
    outline: 'none',
    boxShadow: 24,
};

const closeButton = {
    largeIcon: {
        width: 30,
        height: 30,
        position: 'absolute',
        top: '17px',
        right: '17px',
    },
};
let localSettings;

const sliderOptions = [{ value: 1, label: "Off", scaledValue: 1 },
{ value: 2, label: "Word", scaledValue: 2 },
{ value: 3, label: "Sentence", scaledValue: 3 }]

function SettingModal({ settings, sendSettings, toggleAudio, togglePlay, playerType, changeToCurrentSection, dispatch }) {

    const classes = useStyles();
    const { data, panel } = settings;
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        if (settings && !settings.modalState.isQuestionClicked) {
            setOpen(true);
            if (playerType) {
                // dispatch(settingsPanel(true));
                dispatch(panelClosing({ settingsPanel: true }))
                toggleAudio();
            } else {
                togglePlay && toggleAudio();
            }
        }
    }
    const handleClose = () => {
        setOpen(false);
        changeToCurrentSection();
    }
    const [playbackSpeed, setPlaybackSpeed] = useState(data?.playbackSpeed || 1.0);
    const [fontSize, setFontSize] = useState(data?.fontSize || 1);
    const [bgColor, setBgColor] = useState(data?.bgColor || "#ddf0ff");
    const [fontColor, setFontColor] = useState(data?.fontColor || "#000000")
    const [highlightColor, setHighlightColor] = useState(data?.highlightColor || "#ffdab9");
    const [isHighlighted, setIsHighlighted] = useState(data?.isHighlighted || true);
    const [isSentenceHighlighted, setSentenceHighlighted] = useState(data?.highlightSentence || data?.highlightMode ? false: true);
    const [micPanelOpen, setMicPanelOpen] = useState(false);
    const [selectedToggle, setSelectedToggle] = useState(data?.highlightMode ? 2 : data?.highlightSentence ? 3 : 3);
    const [followAlong,setFollowAlong] =useState(data?.followAlong || false);
    useEffect(() => {
        console.log("data ", data);
        if (data) {
            setFontSize(data.fontSize);
            setBgColor(data.bgColor);
            setFontColor(data.fontColor);
            setHighlightColor(data.highlightColor);
            setIsHighlighted(data.highlightMode);
            setPlaybackSpeed(data.playbackSpeed);
            setSentenceHighlighted(data.highlightSentence);
            setSelectedToggle(data?.highlightMode ? 2 : data?.highlightSentence ? 3 : 1);
            setFollowAlong(data?.followAlong);
            sendSettings(data);
        }
    }, [data])

    useEffect(() => {
        console.log("panel ", panel);
        if (panel.soundSettingsPanel) {
            setOpen(true);
        }
    }, [panel])

    useEffect(() => {
        localSettings = {
            bgColor,
            fontColor,
            highlightColor,
            highlightMode: isHighlighted,
            fontSize,
            playbackSpeed,
            highlightSentence: isSentenceHighlighted,
            followAlong: followAlong
        }
        sendSettings(localSettings);
        open && dispatch(postSettings(localSettings));
    }, [bgColor, fontColor, highlightColor, fontSize, playbackSpeed, isHighlighted, isSentenceHighlighted, followAlong])

    useEffect(() => {
        if (open) {
            dispatch(handleSettingsMenuState(true));
        } else {
            dispatch(handleSettingsMenuState(false));
        }

        if (open && !playerType && togglePlay) {
            toggleAudio();
        }
    }, [open, togglePlay, playerType])

    const getPlaybackSpeed = (e, val) => {
        setPlaybackSpeed(val);
    }

    const getFontSize = (e, val) => {
        setFontSize(val);

        console.log(e.target);
    }

    const pickBgColor = (color) => {
        setBgColor(color.hex);
    }

    const pickFontColor = (color) => {
        setFontColor(color.hex);
    }

    const pickHighlightColor = (color) => {
        setHighlightColor(color.hex);
    }

    // const switchHighlight = (event) => {
    //     if (event.target.checked) {
    //         setSentenceHighlighted(false);

    //         setSelectedToggle(2);
    //     }
    //     if (!event.target.checked) {
    //         setSentenceHighlighted(false);
    //         setSelectedToggle(1);
    //     }
    //     setIsHighlighted(event.target.checked);
    // };
    const handleToggle = (event) => {
        setSelectedToggle(event.target.value);
        if (event.target.value == 1) {
            setIsHighlighted(false);
            setSentenceHighlighted(false);
        }
        else if (event.target.value == 2) {

            setIsHighlighted(true);
            setSentenceHighlighted(false);
        } else {

            setIsHighlighted(false);
            setSentenceHighlighted(true);
        }
    }
    const handleReset = () => {
        setPlaybackSpeed(1);
        setFontSize(1);
        setBgColor("#ddf0ff");
        setFontColor("#000000");
        setHighlightColor("#ffdab9");
        setIsHighlighted(false);
        setSentenceHighlighted(true);
        setSelectedToggle(3);
        setFollowAlong(false);
        let obj = {
            bgColor: "#ddf0ff",
            fontColor: "#000000",
            highlightColor: "#ffdab9",
            highlightMode: false,
            fontSize: 1,
            playbackSpeed: 1,
            highlightSentence: true,
            followAlong: false
        }
        sendSettings(obj);
        dispatch(postSettings(obj));
    }

    const handleMicTesting = () => {
        dispatch(soundSettings(true));
    }
    return (
        <div>
            <Settings onClick={handleOpen} className="settings_icon" />
            <Modal
                open={open}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                {!panel.soundSettingsPanel ?
                    <Box sx={style} className='settings_modal'>
                        <Typography id="modal-title" variant="h6" component="div" mb={2}>
                            Settings
                        </Typography>
                        <IconButton
                            variant="contained"
                            onClick={handleClose}
                            style={closeButton.largeIcon}
                            className='closeBtnIcon'
                        >
                            <Tooltip title="Close" className="settings_close_tooltip">
                                <Close className="settings_close_icon" />
                            </Tooltip>
                        </IconButton>
                        <Typography component="div" id="modal-description">
                            <div className='settings_modal_container'>
                                <div className="inLine">
                                    <label>
                                        Background Color:
                                    </label>
                                    <PopoverPicker color={bgColor} onChange={pickBgColor} />
                                </div>
                                <div className="inLine">
                                    <label>
                                        Font Color:
                                    </label>
                                    <PopoverPicker color={fontColor} onChange={pickFontColor} />
                                </div>

                                <div className="inLine">
                                    <label>
                                        Highlight Color:
                                    </label>
                                    <PopoverPicker color={highlightColor} onChange={pickHighlightColor} />
                                </div>

                                <div className="inLine">
                                    <label>
                                        Font Size:
                                    </label>
                                    <div>
                                        <Slider
                                            aria-label="Font Size"
                                            defaultValue={0.5}
                                            min={0.7}
                                            max={2}
                                            step={0.1}
                                            data-sizing="em"
                                            value={fontSize}
                                            valueLabelDisplay="auto"
                                            onChange={getFontSize}
                                        />
                                    </div>
                                </div>

                                <div className="inLine">
                                    <label>
                                        Speaking Speed:
                                    </label>
                                    <div>
                                        <Slider
                                            aria-label="Playback Speed"
                                            defaultValue={.9}
                                            min={0.5}
                                            max={2}
                                            step={0.1}
                                            value={playbackSpeed}
                                            valueLabelDisplay="auto"
                                            onChange={getPlaybackSpeed}
                                        />
                                    </div>
                                </div>
                                <div className="inLine">
                                    <label>
                                    Text Highlighting:
                                    </label>
                                    <Slider
                                        aria-label="Highlight"
                                        defaultValue={2}
                                        step={1}
                                        marks={sliderOptions}
                                        value={selectedToggle}
                                        min={1}
                                        max={3}
                                        onChange={handleToggle}
                                        style={{marginTop:"8px"}}
                                    />
                                </div>
                                <div className="inLine">
                                    <label>
                                        Follow  Along:
                                    </label>
                                    <Switch
                                        checked={followAlong}
                                        onChange={() => { setFollowAlong(!followAlong) }}
                                        className={classes.switchStyle}
                                        color='primary'
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </div>
                                <div className="inLine"></div>
                                <div className="inLine settings_reset_btn sound_setting_btn">
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={handleMicTesting}
                                    >Sound Settings</Button>
                                </div>

                                <div className="inLine settings_reset_btn">
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={handleReset}
                                    >Reset</Button>
                                </div>
                            </div>
                        </Typography>
                    </Box> :
                    <InputDeviceSetting />
                }
            </Modal>
        </div>
    )
}

const mapState = ({ platform: { settings } }) => {
    return {
        settings
    }
};

export default connect(mapState)(SettingModal);